import { useMe } from '@chipn/queries';
import { Link, Outlet } from '@tanstack/react-router';

// The header is primary in light mode and a dark surface in dark mode, so link colors follow each.
const navLink = [
  'flex min-h-11 items-center rounded-[10px] px-3 text-sm font-semibold',
  'text-white/80 hover:text-white [&.active]:bg-white/15 [&.active]:text-white',
  'dark:text-text-muted dark:hover:text-text dark:[&.active]:bg-surface-muted dark:[&.active]:text-text',
].join(' ');

export function AppShell() {
  const me = useMe();
  return (
    <div className="min-h-dvh">
      <header className="sticky top-0 z-10 bg-primary-500 text-white dark:border-b dark:border-border dark:bg-surface dark:text-text">
        <div className="mx-auto flex max-w-2xl items-center justify-between px-4 py-2">
          <Link to="/" className="text-lg font-bold">
            Chipn
          </Link>
          <nav aria-label="Main" className="flex items-center gap-1">
            <Link to="/" className={navLink} activeOptions={{ exact: true }}>
              Groups
            </Link>
            {me.data?.isStaff && (
              <Link to="/admin" className={navLink}>
                Admin
              </Link>
            )}
            <Link to="/profile" className={navLink}>
              Profile
            </Link>
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-2xl px-4 pt-5 pb-16">
        <Outlet />
      </main>
    </div>
  );
}
